// Case-related constants
export const STATUS_COLORS = {
  NEW: 'bg-blue-500', PENDING_REVIEW: 'bg-yellow-500', ASSIGNED: 'bg-purple-500',
  ACTIVE: 'bg-green-500', EVIDENCE_COLLECTION: 'bg-cyan-500', AWAITING_CLIENT_INFO: 'bg-orange-500',
  UNDER_REVIEW: 'bg-indigo-500', COMPLETED: 'bg-emerald-500', CLOSED: 'bg-slate-500'
};

export const STATUSES = ['NEW','PENDING_REVIEW','ASSIGNED','ACTIVE','EVIDENCE_COLLECTION','AWAITING_CLIENT_INFO','UNDER_REVIEW','COMPLETED','CLOSED'];

export const RISK_COLORS = { LOW: 'bg-green-500', MEDIUM: 'bg-yellow-500', HIGH: 'bg-orange-500', CRITICAL: 'bg-red-500' };

export const LEAD_STATUS_COLORS = { NEW: 'bg-blue-500', INVESTIGATING: 'bg-yellow-500', VERIFIED: 'bg-green-500', DEAD_END: 'bg-red-500', CLOSED: 'bg-slate-500' };

export const LOCATION_TYPES = [
  { value: 'HOME', label: 'Home' },
  { value: 'WORK', label: 'Work' },
  { value: 'VEHICLE_LOCATION', label: 'Vehicle Location' },
  { value: 'MEETING_POINT', label: 'Meeting Point' },
  { value: 'SURVEILLANCE_POINT', label: 'Surveillance Point' },
  { value: 'OTHER', label: 'Other' }
];

export const EVIDENCE_TYPES = [
  { value: 'DOCUMENT', label: 'Document' },
  { value: 'PHOTO', label: 'Photo' },
  { value: 'VIDEO', label: 'Video' },
  { value: 'AUDIO', label: 'Audio' },
  { value: 'DIGITAL', label: 'Digital' },
  { value: 'PHYSICAL', label: 'Physical' },
  { value: 'OTHER', label: 'Other' }
];

export const NOTE_CATEGORIES = [
  'General', 'Meeting Notes', 'Field Observations', 'Analysis', 
  'Client Communication', 'Legal', 'Administrative', 'Other'
];

export const NOTE_VISIBILITIES = [
  { value: 'INTERNAL_ONLY', label: 'Internal Only' },
  { value: 'CLIENT_VIEWABLE', label: 'Client Viewable' },
  { value: 'ADMIN_ONLY', label: 'Admin Only' }
];

export const ASSIGNMENT_ROLES = [
  { value: 'lead_investigator', label: 'Lead Investigator' },
  { value: 'field_investigator', label: 'Field Investigator' },
  { value: 'support', label: 'Support' },
  { value: 'reviewer', label: 'Reviewer' }
];
